import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import "./Home.css";
import karan from "../../assets/Core/img-karan.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import About from "../About/About";
import {
  faHtml5,
  faCss3Alt,
  faJs,
  faReact,
  faPython,
  faAws,
  faNodeJs,
} from "@fortawesome/free-brands-svg-icons";

const Home = () => {
  // Memoize skill icons for performance
  const skills = useMemo(
    () => [
      { icon: faHtml5, label: "HTML5" },
      { icon: faCss3Alt, label: "CSS3" },
      { icon: faJs, label: "JavaScript" },
      { icon: faReact, label: "React.js" },
      { icon: faPython, label: "Python" },
      { icon: faAws, label: "AWS" },
      { icon: faNodeJs, label: "Node.js" },
    ],
    []
  );

  return (
    <>
      <Helmet>
        <title>Karan Kumar Agrawal | Full Stack Developer & Entrepreneur</title>
        <meta
          name="description"
          content="Portfolio of Karan Kumar Agrawal – Full Stack Developer, Entrepreneur, and Tech Enthusiast. Explore projects, skills, and contact information."
        />
        <meta
          name="keywords"
          content="Karan Kumar Agrawal, Full Stack Developer, Portfolio, React.js, Node.js, Python, AWS, Web Development"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://karan.inditech.in/" />

        {/* Open Graph for social media previews */}
        <meta property="og:title" content="Karan Kumar Agrawal | Full Stack Developer" />
        <meta
          property="og:description"
          content="Portfolio of Karan Kumar Agrawal – Full Stack Developer, Entrepreneur, and Tech Enthusiast."
        />
        <meta property="og:url" content="https://karan.inditech.in/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://karan.inditech.in/logo512.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Karan Kumar Agrawal | Full Stack Developer" />
        <meta
          name="twitter:description"
          content="Portfolio of Karan Kumar Agrawal – Full Stack Developer, Entrepreneur, and Tech Enthusiast."
        />
        <meta name="twitter:image" content="https://karan.inditech.in/logo512.png" />
      </Helmet>

      <main className="home-main">
        <section className="home-core">
          <img
            className="home-hero-img"
            src={karan}
            alt="Karan Kumar Agrawal Portrait"
            loading="lazy"
          />
          <div className="home-hero-content">
            <div>
              <h1>Hi! I'm</h1>
              <h1 className="home-hero-name">Karan Kumar Agrawal</h1>
              <h2 className="designation">Managing Director</h2>
              <h3 className="designation2">Vyska Technologies Pvt. Ltd.</h3>
            </div>
            <div className="home-hero-skills">
              {skills.map((skill) => (
                <FontAwesomeIcon
                  key={skill.label}
                  className="home-hero-skill-icon"
                  icon={skill.icon}
                  title={skill.label} // improves accessibility
                />
              ))}
            </div>
            <div className="home-hero-skills">
            <a
              href="https://wa.me/919827023035?text=Hello%20Karan%2C%20I%20came%20across%20your%20portfolio%20and%20would%20like%20to%20connect%20regarding%20a%20potential%20collaboration."
              target="_blank"
              rel="noreferrer"
              aria-label="Chat with Karan on WhatsApp"
              className="whatsapp-link"
            >
              <button className="Btn">
                <div className="sign">
                  <svg className="socialSvg whatsappSvg" viewBox="0 0 16 16">
                    <path
                      d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                    ></path>
                  </svg>
                </div>

                <div className="text">Connect</div>
              </button>
            </a>
              <a
                href="https://www.linkedin.com/in/karan-agrawal25/"
                target="_blank"
                rel="noreferrer"
                aria-label="Visit Karan's LinkedIn Profile"
                className="lnkd-link"
              >
                <button className="lnkd-Btn">
                  <div className="lnkd-sign">
                    <svg
                      fill="white"
                      className="lnkd-svgIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      height="1.6em"
                      viewBox="0 0 448 512"
                    >
                      <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"></path>
                    </svg>
                  </div>

                  <div className="lnkd-text">LinkedIn</div>
                </button>
              </a>
                </div>





          </div>
        </section>

        {/* 
  Social Links Section (Commented Out)

  <section className="home-social-container">
    <div className="social-main">
      <div className="social-up">
        <a
          href="https://www.linkedin.com/in/karan-agrawal25/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn Profile"
        >
          <button className="social-card card1">
            <FontAwesomeIcon icon={faAws} /> 
          </button>
        </a>
        <a
          href="https://x.com/karann__25"
          target="_blank"
          rel="noreferrer"
          aria-label="X Profile"
        >
          <button className="social-card card2"></button>
        </a>
      </div>
      <div className="social-down">
        <a
          href="https://github.com/KDrop25"
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub Profile"
        >
          <button className="social-card card3"></button>
        </a>
        <a
          href="mailto:karan25.pvt@gmail.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Send Email"
        >
          <button className="social-card card4"></button>
        </a>
      </div>
    </div>
  </section>
*/}


        {/* About Section */}
        
      </main>
      <About />
    </>
  );
};

export default Home;
